// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".compare[data-v-14d6e381]{padding:1rem 0;text-align:center}@media (min-width:768px){.compare[data-v-14d6e381]{padding:2rem 0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
